import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

function InfoOverlay({
  name,
  info,
  unRegistered,
  participantInfo = false,
  supporterInfo = false,
  miscInfo = false,
  vehicleSharingInfo = false,
  winnerInfo = false,
}) {
  return (
    <>
      {participantInfo && (
        <OverlayTrigger
          trigger='click'
          rootClose={true}
          key={name}
          placement='bottom'
          overlay={
            <Popover id='popover-positioned-bottom'>
              <Popover.Body>
                <Row>
                  <Col>
                    <p>Födelsedatum</p>
                    <p>E-post</p>
                    <p>Telenr.</p>
                    <p>Adress</p>
                  </Col>
                  <Col>
                    {info?.birthDate ? (
                      <p>
                        {info.birthDate.year}-{info.birthDate.month}-
                        {info.birthDate.day}
                      </p>
                    ) : (
                      <p>Ej angett</p>
                    )}
                    {info?.email ? <p>{info.email}</p> : <p>Ej angett</p>}
                    {info?.phoneNumber ? (
                      <p>{info.phoneNumber}</p>
                    ) : (
                      <p>Ej angett</p>
                    )}
                    {info?.adress ? <p>{info.adress}</p> : <p>Ej angett</p>}
                  </Col>
                </Row>
              </Popover.Body>
            </Popover>
          }
        >
          {unRegistered ? (
            <span
              className='d-flex align-items-center bg-danger text-black p-1 cursor-pointer'
              style={{ cursor: 'pointer' }}
            >
              {name}
              <span className='material-symbols-outlined ms-1'>info</span>
            </span>
          ) : (
            <span
              className='d-flex align-items-center bg-info text-black p-1 cursor-pointer'
              style={{ cursor: 'pointer' }}
            >
              {name}
              <span className='material-symbols-outlined ms-1'>info</span>
            </span>
          )}
        </OverlayTrigger>
      )}
      {supporterInfo && (
        <OverlayTrigger
          trigger='click'
          rootClose={true}
          key={name}
          placement='bottom'
          overlay={
            <Popover id='popover-positioned-bottom'>
              <Popover.Body>
                <Row>
                  <Col>
                    <p>Licens</p>
                    <p>E-post</p>
                    <p>Telenr.</p>
                    <p>Adress</p>
                  </Col>
                  <Col>
                    <p>{info.licens ? info.licens : 'Ej angett'}</p>
                    <p>{info.email ? info.email : 'Ej angett'}</p>
                    <p>{info.phoneNumber ? info.phoneNumber : 'Ej angett'}</p>
                    <p style={{ whiteSpace: 'noWrap' }}>
                      {info.street ? info.street : 'Ej angett'}
                      <br />
                      {info.zipCode}
                      <br />
                      {info.city}
                    </p>
                  </Col>
                </Row>
              </Popover.Body>
            </Popover>
          }
        >
          <span
            className='d-flex align-items-center bg-light text-black p-1'
            style={{ cursor: 'pointer' }}
          >
            {name}
            <span className='material-symbols-outlined ms-1'>info</span>
          </span>
        </OverlayTrigger>
      )}
      {miscInfo && (
        <OverlayTrigger
          trigger='click'
          rootClose={true}
          key={info}
          placement='bottom'
          overlay={
            <Popover id='popover-positioned-bottom'>
              <Popover.Body>
                <span
                  style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {info}
                </span>
              </Popover.Body>
            </Popover>
          }
        >
          <span
            className='d-flex align-items-center bg-light text-black p-1 cursor-pointer'
            style={{ cursor: 'pointer' }}
          >
            {info.length > 20 ? info.slice(0, 19) + '...' : info}
            <span className='material-symbols-outlined ms-1'>info</span>
          </span>
        </OverlayTrigger>
      )}
      {vehicleSharingInfo && (
        <OverlayTrigger
          trigger='click'
          rootClose={true}
          key={name}
          placement='bottom'
          overlay={
            <Popover id='popover-positioned-bottom'>
              <Popover.Body>
                <span>{info}</span>
              </Popover.Body>
            </Popover>
          }
        >
          <span
            className='d-flex align-items-center bg-light text-black p-1 cursor-pointer'
            style={{ cursor: 'pointer' }}
          >
            {name}
            <span className='material-symbols-outlined ms-1'>info</span>
          </span>
        </OverlayTrigger>
      )}
      {winnerInfo && (
        <OverlayTrigger
          trigger='click'
          rootClose={true}
          key={name}
          placement='bottom'
          overlay={
            <Popover id='popover-positioned-bottom'>
              <Popover.Body>
                <Row>
                  <Col>
                    <p>E-post</p>
                    <p>Telenr.</p>
                    <p>Adress</p>
                    <p>Personnr.</p>
                  </Col>
                  <Col>
                    <p>{info.email ? info.email : 'Ej angett'}</p>
                    <p>{info.phoneNumber ? info.phoneNumber : 'Ej angett'}</p>
                    <p style={{ whiteSpace: 'noWrap' }}>
                      {info.adress ? info.adress : 'Ej angett'}
                    </p>
                    <p>
                      {info.birthDate?.year}-{info.birthDate?.month}-
                      {info.birthDate?.day}
                    </p>
                  </Col>
                </Row>
              </Popover.Body>
            </Popover>
          }
        >
          <span
            className='d-flex align-items-center bg-light text-black p-1'
            style={{ cursor: 'pointer' }}
          >
            {name}
            <span className='material-symbols-outlined ms-1'>info</span>
          </span>
        </OverlayTrigger>
      )}
    </>
  );
}

export default InfoOverlay;
